import { createAction, props } from "@ngrx/store";

export const handleError = createAction(
    "[Core] Error",
    props<{ error: string, showToast?: boolean, exception?: any }>()
);

export const errorHandled = createAction("[Core] Error Handled");